export default __webpack_public_path__ + "static/media/O-116.f59c6fed.png";